export function normalizeSsn(value: string): string {
  return value.replace(/\D/g, "").slice(0, 9);
}

/** SSA SSN / IRS ITIN: 9 digits (XXX-XX-XXXX). No public check-digit algorithm. */
export function isValidSsn(value: string): boolean {
  const digits = normalizeSsn(value);
  if (digits.length !== 9) return false;
  return !/^(\d)\1+$/.test(digits);
}

export function formatSsn(value: string): string {
  const digits = normalizeSsn(value);
  if (digits.length === 0) return "";
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
}

export function maskSsnInput(raw: string): string {
  return formatSsn(raw);
}
